export const UPDATE_DESKTOP_MODE = "UPDATE_DESKTOP_MODE";
export const UPDATE_WISHLIST_CART_COUNT = "UPDATE_WISHLIST_CART_COUNT";
export const UPDATE_RESTAURANT_REVIEWS = "UPDATE_RESTAURANT_REVIEWS";
export const SOCKET_DATA = "SOCKET_DATA";
